<template>
  <div class="container">
    <img :src="info.imgUrl" alt="" class="pt-4" />
    <!-- <h2 class="manrope">{{ info.title }}</h2> -->
    <h2 class="manrope bold pt-4 text-center">
      Choose your Level
    </h2>
    <div class="grid pt-2 pb-5">
      <div class="manrope">
        <a :href="info.quizLink1" target="_blank" rel="noopener noreferrer">
          Junior Level >
        </a>
      </div>
      <div class="manrope">
        <a :href="info.quizLink2" target="_blank" rel="noopener noreferrer">
          Mid Level >
        </a>
      </div>
      <div class="manrope" v-if="!info.quizLink3">
        <a :href="info.quizLink3" target="_blank" rel="noopener noreferrer">
          Senior Level >
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    info: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
}
</style>
